import React, { useState } from 'react'
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { useFormik } from "formik";
import * as Yup from "yup";
import images from '../../../assets/images/constantImages';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

const LoginCanteenUser = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      full_name: "",
      mobile_no: "",
    },
    validationSchema: Yup.object({
      full_name: Yup.string()
        .matches(/^[a-zA-Z\s]+$/, "Only alphabets and spaces are allowed")
        .min(3, "Name must be at least 3 characters")
        .max(50, "Name can't exceed 50 characters")
        .required("Full name is required"),
      mobile_no: Yup.string()
        .required("Mobile number is required"),
    }),
    onSubmit: async (values) => {
      console.log(values);
      setIsSubmitting(true)
      try {
        const formData = new FormData();
        formData.append("full_name", values.full_name);
        formData.append("mobile_no", values.mobile_no);
        const response = await axios.post("https://headquater.pixoatic.com/api/v1/customer_users/request_otp", formData, {
          headers: { "Content-Type": "application/json" },
        });
        console.log(response);
        const canteenId = response.data.id
        if (canteenId) {
          localStorage.setItem("canteenId", canteenId);
          localStorage.setItem("fullname", response.data.name);
        }
        setTimeout(() => {
          navigate("/otpCanteen")
        }, 100)

      } catch (errors) {
        toast.error(errors?.response?.data?.errors);
      } finally {
        setIsSubmitting(false);
      }
    },
  });

  return (
    <>
      <div className="w-full flex relative justify-center items-center">
        <div className="absolute top-0 z-10 w-full">
          <img
            src={images.loginclipimage}
            alt=""
            className="w-full h-screen opacity-[8%]"
          />
        </div>
        <div className="md:w-[50%] md:bg-white flex justify-center items-center md:relative absolute inset-0 z-20 rounded-md">
          <div className="bg-white w-[310px] py-3 px-5 xs:w-[430px] md:w-[400px] lp:w-[450px] flex flex-col">
            <h1 className="text-G800 font-bold text-2xl xs:text-[30px] text-center mb-2">
              Welcome <span className='text-canteengreen'>!</span>
            </h1>

            <p className="text-center text-G200 font-normal text-sm xs:text-[16px] leading-[24px] mb-4 md:mb-5">
              Lorem Ipsum is simply dummy text of the printing and
              typesetting industry.
            </p>
            <form onSubmit={formik.handleSubmit} className="flex flex-col gap-3">
              <div>
                <label className="block text-sm text-G200 mb-2">Full Name</label>
                <input
                  type="text"
                  name="full_name"
                  value={formik.values.full_name}
                  placeholder="Enter your name"
                  onChange={formik.handleChange}
                  className="inputtext"
                />
                {formik.touched.full_name && formik.errors.full_name && (
                  <div className="text-red text-sm">{formik.errors.full_name}</div>
                )}
              </div>
              <div className=''>
                <label className="block text-sm mb-2 text-G200">Enter Phone number</label>
                <PhoneInput
                  country={'in'}
                  value={formik.values.mobile_no}
                  onChange={(value) => formik.setFieldValue('mobile_no', value)}
                  onBlur={formik.handleBlur}
                  onlyCountries={['in']}
                  disableDropdown={true}
                  countryCodeEditable={false}
                  inputProps={{
                    name: 'mobile_no',
                    required: true,
                    className: 'w-full inputtext',
                  }}
                  inputStyle={{ paddingLeft: '50px' }}
                />
                {formik.errors.mobile_no && formik.touched.mobile_no && (
                  <div className="text-red text-sm">
                    {formik.errors.mobile_no}
                  </div>
                )}
              </div>
              <button
                type="submit"
                className={` font-semibold text-base md:text-lg text-center py-2 rounded-lg mt-5 md:mt-10
                  ${isSubmitting ? "bg-green50 text-canteengreen cursor-not-allowed" : "bg-canteengreen text-white"}`}
                disabled={isSubmitting}
              >
                {isSubmitting ? "continueing ..." : "Continue"}
              </button>
            </form>
          </div>
        </div>
        <div className="md:w-[50%] ">
          <img src={images.platesimages} alt="platesimages" loading='lazy' className='w-full h-screen' />
        </div>
      </div>
    </>

  )
}

export default LoginCanteenUser;